import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const storageKey = 'rememberLoginOrganisation';

const strAtomWithStorage = atomWithStorage(storageKey, '');

const boolAtomWithStorage = atom(
  get => !!get(strAtomWithStorage),
  (_, set, val: boolean) => {
    set(strAtomWithStorage, val ? 'true' : '');
  },
);

const useRememberLoginOrganisation = () => useAtom(boolAtomWithStorage);

export default useRememberLoginOrganisation;
